import React from 'react';
import { useTranslation } from 'react-i18next';

import { defaultLocale } from 'utils/languages';

import { GalleryModal } from '@weezevent/gallery-front';

import UnlayerEmailEditor from 'react-email-editor';

const PROJECT_ID = '122'; // Weezevent's Unlayer project ID

const Editor = ({ organizationId, bodies, selectedLanguage, handleChange }) => {
    const { i18n } = useTranslation();
    const editor = React.useRef(null);
    const [doneCB, setDoneCB] = React.useState(null);

    const selectedUnlayerEntry = React.useMemo(() => bodies.find(it => it.lang === selectedLanguage), [bodies, selectedLanguage]);

    const sync = React.useCallback(() => {
        editor.current.exportHtml(({ html, design }) => {
            let _bodies = bodies.reduce((acc, bd) => {
                if (bd.lang === selectedLanguage) {
                    bd.content_html = html;
                    bd.content_json = design;
                }
                acc.push(bd);
                return acc;
            }, []);

            if (!selectedUnlayerEntry) {
                _bodies = [...bodies, { lang: selectedLanguage, content_html: html, content_json: design }];
            }

            handleChange(_bodies);
        });
    }, [bodies, editor.current, selectedLanguage, selectedUnlayerEntry, handleChange]);

    const onSelected = React.useCallback(
        url => {
            doneCB({ url });
            setDoneCB(null);
        },
        [doneCB]
    );

    const onCancel = React.useCallback(() => {
        setDoneCB(null);
    }, [setDoneCB]);

    const onReady = React.useCallback(() => {
        setImmediate(() => {
            const input_json = selectedUnlayerEntry?.content_json;

            if (!editor.current) {
                return;
            }
            if (input_json) {
                editor.current.loadDesign(input_json);
            }

            editor.current.registerCallback('selectImage', function(data, done) {
                setDoneCB(() => done);
            });

            editor.current.addEventListener('design:updated', sync);
        });
    }, [editor.current, selectedUnlayerEntry, sync]);

    return (
        <>
            <GalleryModal
                isOpenModal={Boolean(doneCB)}
                onSelected={onSelected}
                onClose={onCancel}
                organization={{ id: organizationId }}
                apiKeyUnsplash={window.weezConfig.unsplash}
            />
            <UnlayerEmailEditor
                ref={editor}
                onReady={onReady}
                key={selectedLanguage}
                projectId={PROJECT_ID}
                locale={defaultLocale(i18n.language)}
                options={{
                    features: {
                        stockImages: false,
                        textEditor: {
                            tables: true,
                            spellChecker: true
                        }
                    }
                }}
                appearance={{
                    theme: 'dark',
                    panels: {
                        tools: {
                            dock: 'left'
                        }
                    }
                }}
            />
        </>
    );
};

export default Editor;
